import { render } from "./LocationLayer.vue?vue&type=template&id=c4f645b8&scoped=true"
import script from "./LocationLayer.vue?vue&type=script&lang=js"
export * from "./LocationLayer.vue?vue&type=script&lang=js"

import "./LocationLayer.vue?vue&type=style&index=0&id=c4f645b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f645b8"]])

export default __exports__